import { useState, useEffect } from 'react'
import { Box } from '@mui/material'
import Grid from '@mui/material/Grid'
import {
  AccordionHead,
  StyledAccordionJourney
} from 'components/atoms/container/Accordion'
import PathCard from 'components/molecules/home/PathCard'
import StyledAutoComplete from 'components/atoms/input/StyledAutoComplete'
import { useTranslation } from 'react-i18next'
import colors from 'styles/colors'
import RowStack from 'components/atoms/container/RowStack'

const PathList = ({ goals }) => {
  const { t } = useTranslation()
  const [displayGoals, setDisplayGoals] = useState(goals)
  const [expanded, setExpanded] = useState(false)
  const [selectedLeaaderShips, setSelectedLeaaderShips] = useState([])
  const [selectedVirtueFilters, setSelectedVirtueFilters] = useState([])

  const leaaderShipFilters = [
    ...new Set(
      goals.map(goal => goal.leadershipModelName)
    )
  ]
  const virtueFilters = [
    ...new Set(
      goals
        .map(goal => goal.virtues.map(v => v.name))
        .flat()
    )
  ]

  useEffect(() => {
    if (selectedLeaaderShips.length === 0 && selectedVirtueFilters.length === 0)
      return setDisplayGoals(goals)

    const newData = goals.filter(goal => {
      return (
        selectedLeaaderShips.some(f => goal.leadershipModelName === f.value) ||
        selectedVirtueFilters.some(f =>
          goal.virtues.map(v => v.name).includes(f.value)
        )
      )
    })
    setDisplayGoals(newData)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedLeaaderShips, selectedVirtueFilters])

  const filterData = (filter, isVirtue) => {
    if (isVirtue) {
      setSelectedVirtueFilters(filter)
    } else {
      setSelectedLeaaderShips(filter)
    }
  }

  return (
    <>
      <Box>
        <StyledAccordionJourney
          summaryComponent={
            <AccordionHead
              heading={t('home.learningPathLibrary')}
              headingProps={{ variant: 'h2' }}>
              {expanded && (
                <RowStack
                  spacing={4}
                  width={'auto'}
                  style={{ marginRight: 8 }}
                  onClick={e => e.stopPropagation()}>
                  <StyledAutoComplete
                    options={leaaderShipFilters.map(f => ({
                      label: f,
                      value: f
                    }))}
                    selectedOptions={selectedLeaaderShips}
                    onSelection={filter => filterData(filter, false)}
                    placeholder={t('home.themes')}
                  />

                  <StyledAutoComplete
                    options={virtueFilters.map(f => ({ label: f, value: f }))}
                    selectedOptions={selectedVirtueFilters}
                    onSelection={filter => filterData(filter, true)}
                    placeholder={`${t('home.skill')}s`}
                  />
                </RowStack>
              )}
            </AccordionHead>
          }
          initialExpanded={false}
          expandCallback={isExpanded => setExpanded(isExpanded)}
          padding={10}
          borderColor={colors.Transparent}
          bgColor={colors.MetalGrey50}>
          <Grid container spacing={0} gap={12} paddingTop={8}>
            {displayGoals.map((goal, index) => (
              <Grid key={`goal-${index}`} size={{ md: 3.8, lg: 2.8 }}>
                <PathCard goal={goal} isLibrary={true} />
              </Grid>
            ))}
          </Grid>
        </StyledAccordionJourney>
      </Box>
    </>
  )
}

export default PathList
